module.exports = __webpack_public_path__ + "static/media/crop-health.56c4e307.png";